import get from 'lodash/get';
import Auth from '@Services/Auth';
import Register from '@Services/Register';
import RegisterData from '@Services/RegisterData';
import Catalyst from '@Services/Catalyst';

import { openConfirmationEmailSentDialog } from '@Pages/Login/RegisterConfirmation/RegisterConfirmationActions';
import { login } from '@Pages/Login/Register/RegisterActions';
import {
  registerFinalizeSetIsLoadingReducerType,
  registerFinalizeSetIpAddressReducerType,
  registerFinalizeSetMarketingInfoReducerType,
  registerFinalizeSetDataReducerType,
  registerFinalizeSetFailReducerType,
} from './RegisterFinalizeConstants';

import { data as dataSelector } from './RegisterFinalizeSelectors';
import { initialState } from './RegisterFinalizeReducer';
import { trackRegistrationErrors } from '../Register/analytics';

export function setIpAddress(ipAddress) {
  return {
    type: registerFinalizeSetIpAddressReducerType,
    payload: { ipAddress },
  };
}

export function setIsLoading(isLoading) {
  return {
    type: registerFinalizeSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export function setMarketingInfo(marketingInfo) {
  return {
    type: registerFinalizeSetMarketingInfoReducerType,
    payload: { marketingInfo },
  };
}

export function setData(data) {
  return {
    type: registerFinalizeSetDataReducerType,
    payload: { data },
  };
}

export function setRegisterFinalizeFail(message) {
  return {
    type: registerFinalizeSetFailReducerType,
    payload: message,
  };
}

export const init = () => async (dispatch) => {
  const registerData = await Register.getData();
  dispatch(setData(registerData));
  await RegisterData.getIpAddress()
    .then((ip) => {
      dispatch(setIpAddress(ip));
    })
    .catch(Logger.error);

  await RegisterData.getCombinedInfo()
    .then((data) => {
      const marketingInfo = get(data, 'PROFILE', data);
      dispatch(setMarketingInfo(marketingInfo));
    })
    .catch(Logger.error);
};

export const submit = () => async (dispatch, getState) => {
  const data = dataSelector(getState());

  const registerData = {
    ...data,
    subjectAreas: [data.subjectAreas],
  };
  dispatch(setRegisterFinalizeFail(null));
  dispatch(setIsLoading(true));

  try {
    const result = await RegisterData.register(registerData);

    Catalyst.trackRegistrationCompleted();

      if (result) {
        // Case when email verification is disabled
        const loginData = {
          username: result.username,
          password: data.password,
          ...(data.rememberMe && { remember_me: data.rememberMe }),
        };
        if (Auth.getAccessToken()) {
          await Auth.logout();
        }
        await dispatch(login(loginData));
      } else {
        // Case when email verification is enabled
        dispatch(openConfirmationEmailSentDialog({ email: data.email }));
      }
    } catch (err) {
      trackRegistrationErrors([err.message], false);
      dispatch(setRegisterFinalizeFail(err.message));
    }

  dispatch(setIsLoading(false));
};

export const resetState = () => {
  return async (dispatch) => {
    dispatch(setData(initialState.get('data')));
    dispatch(setRegisterFinalizeFail(initialState.get('registerFinalizeFail')));
  };
};

export const skip = () => {
  return async (dispatch, getState) => {
    const data = dataSelector(getState());

    dispatch(setRegisterFinalizeFail(null));
    dispatch(setIsLoading(true));

    try {
      const result = await RegisterData.register({
        ...data,
        subjectAreas: [],
        userRole: undefined,
        organizationType: undefined,
        organizationName: undefined,
      });

      Catalyst.trackRegistrationCompleted();

      if (result) {
        const loginData = {
          username: result.username,
          password: data.password,
          ...(data.rememberMe && { remember_me: data.rememberMe }),
        };
        if (Auth.getAccessToken()) {
          await Auth.logout();
        }
        await dispatch(login(loginData));
      } else {
        dispatch(openConfirmationEmailSentDialog({ email: data.email }));
      }
    } catch (err) {
      trackRegistrationErrors([err.message], false);
      dispatch(setRegisterFinalizeFail(err.message));
    }

    dispatch(setIsLoading(false));
  };
};
